<svg
  class="tw-align-middle"
  [class]="iconClass || iconSize"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <use [attr.xlink:href]="'assets/sprites/svg/sprite.css-b23999d3.svg#' + name"></use>
</svg>
